<button
  class="nav-link text-center announcement-badge"
  type="button"
  (click)="toggle()"
  [attr.aria-label]="'ANNOUNCEMENTS.OPEN' | translate"
>
  <i class="lnr lnr-alarm"></i>
  <span
    class="announcement-badge__count"
    *ngIf="(unreadCount$ | async) as count"
    aria-hidden="true"
    >{{ count }}</span
  >
</button>
